import React, { useEffect, useState } from "react";
import { useAppKitAccount } from "@reown/appkit/react";
import PagesIndex from "../../PagesIndex";
import WalletLoader from "../../../components/common/WalletLoader";


export default function ConnectWallet() {
  const navigate = PagesIndex.useNavigate();
  const location = PagesIndex.useLocation();
  const { address } = useAppKitAccount();
  const [isVisible, setIsVisible] = useState(true);
  const themeColor = new URLSearchParams(location.search).get("mode");

  async function handleSell(price, tokenId) {
    navigate("/wallet/address/" + address);
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div
        className={`${
          themeColor === "dark"
            ? "wallet-box wallet-box-content-dark"
            : "wallet-box wallet-box-content"
        }`}
      >
        <div className="wallet-box-cont">
          <div className="logo-box">
            <img src={PagesIndex.Png.logo2} alt="" />
            <div className="logo-title">EPISAP</div>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <appkit-button />
          </div>
          <div
            className="wallet-btn-approve"
            style={{ display: "flex", justifyContent: "center" }}
          >
            {address && (
              <button onClick={() => handleSell()}>Click To Connect</button>
            )}
          </div>
        </div>
      </div>
      {isVisible && (
        <div className="wallet-loader">
          <WalletLoader />
        </div>
      )}
    </>
  );
}
